module.exports = __webpack_public_path__ + "static/image19@2x-4e95643019d46cbdc3f3a4a5a4e663ed.png";